//wait for all images
window.addEventListener("load", (event) => {
  var images = document.querySelectorAll("img");
  var isLoaded;

  images.forEach((image) => {
    isLoaded = image.complete && image.naturalHeight !== 0;
  });

  if (isLoaded) {
    setTimeout(function () {
      document.getElementById("image-slider-list").style.display =
        "inline-flex";
    }, 100);
  } else {
    document.getElementById("image-slider-list").style.display = "none";
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (document.getElementById("image-slider") === null) {
    return;
  }

  var slider = document.getElementsByClassName("splide__list")[0];

  if (slider === null) {
    return;
  }

  var isMobile =
    /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  

  if (slider.children.length > 2) {
   /* var splide = new Splide("#image-slider", {
      type: "loop",
      perMove: 1,
      height: "500px",
      start: 0,
      autoWidth: true,
      trimSpace: true,
      //clones: 7,
      //lazyLoad: true,
    }).mount();
    */
  }else if (slider.children.length == 2) {
    /*var splide = new Splide("#image-slider", {
      type: "loop",
      perMove: 1,
      height: "500px",
      //	focus    : 0,
      start: 0,
      autoWidth: true,
      trimSpace: true,
      clones: 7,
      //lazyLoad: true,
    }).mount();
    */
  } else {
    const arrows = document.getElementById("arrowsSlider");
    arrows.style.visibility = "hidden";
/*
    var splide = new Splide("#image-slider", {
      type: "slide",
      height: "500px",
      drag: false,
      autoWidth: true,
      trimSpace: true,
      lazyLoad: true,
    }).mount();
*/
    //center img wenn 2 oder 1 img
    const ul = document.getElementById("image-slider-list");
    ul.style.display = "inline-flex";
    const track = document.getElementById("image-slider-track");
    track.style.paddingLeft = "36px";
    track.style.marginLeft = "25%";
    
  } 
  /*else {
    var splide = new Splide("#image-slider", {
      type: "loop",
      rewind: false,
      height: "500px",
      autoWidth: true,
      trimSpace: true,
      lazyLoad: true,
      //clones: 7,
      //	focus    : 'center',
      // padding: {
      // 	right: '5rem',
      // 	left : '5rem',
      // },
    }).mount();
  }
*/
  var startIndex = 0;
  var primarySplide = 0;

  var sliderLength = slider.children.length;

  var splide = new Splide("#image-slider", {
      type: sliderLength > 1 ? "loop" : "slide",
      drag: sliderLength > 1 ? true : false,
      rewind: false,
      perMove: 1,
      height: "500px",
      start: startIndex,
      autoWidth: true,
      trimSpace: true,
      lazyLoad: 'nearby',
      updateOnMove: true
    }).mount();

  splide.on("click", function (f) {
    startIndex = f.index;
    
    console.log("INDEX: " + f.index);
    
    var source = document.body; //getElementsByClassName('template-product');
    source.appendChild(document.getElementById("image-slider-light-box"));

    var element = document.getElementById("image-slider-light-box");
    element.classList.remove("hidden");

    primarySplide = new Splide("#image-slider-light-box", {
      type: "loop",
      rewind: false,
      //	heightRatio: 0.5,
      //	pagination : false,
      // arrows     : false,
      autoHeight: true,
      // cover      : false,
      start: f.index,
      //focus: "center",
      height: "100vh",
      width: "100vw",
    });

    // Set the thumbnails slider as a sync target and then call mount.
    primarySplide.sync(splide).mount();

    var closing = document.getElementById("lightbox-close");
    closing.addEventListener("click", () => {
      startIndex = 0;
      
      primarySplide.destroy((completely = true));
      var element = document.getElementById("image-slider-light-box");
      element.classList.add("hidden");
    });

  });

  /*
  primarySplide.on("click", function (f) {
    //	splide.go( '+' );
    var element = document.getElementById("image-slider-light-box");
    element.classList.add("hidden");
    console.log(splide.index);
  });
*/
});
